import {React, useState, useEffect } from "react";
import MuiTable from "../common/MuiTable";
import { FxWindow } from "./../../fxms/windows/FxWindows";
import { FxmsData } from "../../fxms/datas/FxData";
import { UI_6_2_tableRow1,UI_6_2_tableRow2} from "./UI_6_2.helper";
import { UI_6_2_popup } from "./UI_6_2_popup";
import { getInloInfo } from "../common/commonMethod";
import {
  getMonth,
  getMonthBetween
} from "../common/commonMethod";

/*에너지거래>결산관리*/
export const UI_6_2 = (props) => {
  const user = FxmsData.getUser();
  const inlo = getInloInfo(FxmsData.getInlo(user.inloNo),user);
  const [fetchData, setFetchData] = useState([]);
  const [popupData, setPopupData] = useState([]);
  const [fetchComplexInlo, setFetchComplexInlo] = useState([]);
  const [fetchCompanyInlo, setFetchCompanyInlo] = useState([]);
  const [fetchPlantInlo, setFetchPlantInlo] = useState([]);
  const [energyLabel, setEnergyLabel] = useState("");
  const [sinkSourceLabel, setSinkSourceLabel] = useState("매도");
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState({
    sourceSink: "SINK",
    complexInloNo: user.ugrpNo === 1021||user.ugrpNo === 1024? inlo.complexInloNo : "",
    companyInloNo:user.ugrpNo === 1024? inlo.companyInloNo : "",
    plantInloNo: user.ugrpNo === 1024? inlo.inloNo : "",
    energy: "AIR",
    startDate: getMonth(-3),
    endDate:  getMonth(-1)
  });
  const energyOptions = [
    { label: "압축공기", value: "AIR" },
    { label: "스팀", value: "STEAM" }
  ];
  const sourceSinkOptions = [
    { label: "매수", value: "SINK" },
    { label: "매도", value: "SOURCE" }
  ];

  const dataGrid = (
    plantInloName,     // 공장명
    engDescr,    // 에너지종류
    calcYm,       // 정산일
    sinkSource,   // 매수/매도
    deawiStCd,    // 입출금상태
    calcAmt,      // 정산금액
    trnsVol,      // 거래량
    trnsVolChrg,  // 거래량요금
    useUnitPrice, // 사용단가
    baseUnitPrice,// 기준단가
    linkUnitPrice,// 연동단가
    basicChrg,    // 기본요금
    calcStCd,     // 정산상태
  ) => {
    return {
      plantInloName,
      engDescr,
      calcYm,
      sinkSource,
      deawiStCd,
      calcAmt,
      trnsVol,
      trnsVolChrg,
      useUnitPrice,
      baseUnitPrice,
      linkUnitPrice,
      basicChrg,
      calcStCd,
    };
  };

  const popupOpen = (item) => {
    setPopupData(item);
    setIsOpen(true);
  }

  const resultData = fetchData.map(item => {
    return dataGrid(
      item.plantInloName,
      item.engDescr,
      item.calcYm,
      item.sinkSource === "SINK" ? "매수" : item.sinkSource === "SOURCE" ? "매도" : "-",
      item.deawiStCd ? item.deawiStCd : "-",
      item.calcAmt ? new Intl.NumberFormat("ko-KR").format(item.calcAmt) : '-',
      item.trnsVol ? new Intl.NumberFormat("ko-KR").format(item.trnsVol) : '-',
      item.trnsVolChrg ? new Intl.NumberFormat("ko-KR").format(item.trnsVolChrg) : '-',
      item.useUnitPrice ? new Intl.NumberFormat("ko-KR").format(item.useUnitPrice) : '-',
      item.baseUnitPrice ? new Intl.NumberFormat("ko-KR").format(item.baseUnitPrice) : '-',
      item.linkUnitPrice ? new Intl.NumberFormat("ko-KR").format(item.linkUnitPrice) : '-',
      item.basicChrg  ? new Intl.NumberFormat("ko-KR").format(item.basicChrg) : '-',
      item.calcStCd === "4401" ?  <button onClick={() => popupOpen(item)}>결산대기</button>: item.calcStCd === "4409" ? <button onClick={() => popupOpen(item)}>결산완료</button> : "-"
    )
  })

  const resultExcelData = fetchData.map(item => {
    return dataGrid(
      item.plantInloName,
      item.engDescr,
      item.calcYm,
      item.sinkSource === "SINK" ? "매수" : item.sinkSource === "SOURCE" ? "매도" : "-",
      item.deawiStCd ? item.deawiStCd : "-",
      item.calcAmt ? new Intl.NumberFormat("ko-KR").format(item.calcAmt) : '-',
      item.trnsVol ? new Intl.NumberFormat("ko-KR").format(item.trnsVol) : '-',
      item.trnsVolChrg ? new Intl.NumberFormat("ko-KR").format(item.trnsVolChrg) : '-',
      item.useUnitPrice ? new Intl.NumberFormat("ko-KR").format(item.useUnitPrice) : '-',
      item.baseUnitPrice ? new Intl.NumberFormat("ko-KR").format(item.baseUnitPrice) : '-',
      item.linkUnitPrice ? new Intl.NumberFormat("ko-KR").format(item.linkUnitPrice) : '-',
      item.basicChrg  ? new Intl.NumberFormat("ko-KR").format(item.basicChrg) : '-',
      item.calcStCd === "4401" ?  '결산대기': item.calcStCd === "4409" ? '결산완료' : '-'
    )
  })
  
  // complexInloNo가 설정되면 회사 목록을 가져오도록 useEffect 추가
  useEffect(() => {
    if (selected.complexInloNo) {
      selectedComplex(selected.complexInloNo);
    }
  }, [selected.complexInloNo]);

  useEffect(() => {
    console.log("selected ........ ", selected);
  }, [selected])

  useEffect(() => {
    console.log("*** UI_6_2 ***");

    if(user.ugrpNo !== 1021 || user.ugrpNo !== 1024){ //산단      
      getComplexInloData();     
    }

    submitBtnClick();

  }, [inlo,user]);

  useEffect(() => {
    const option = energyOptions.find(option => option.value === selected.energy);
    if (option) {
      setEnergyLabel(option.label);
    }
  }, [selected.energy]);

  useEffect(() => {
    const option = sourceSinkOptions.find(option => option.value === selected.sourceSink);
    if (option) {
      setSinkSourceLabel(option.label);
    }
  }, [selected.sourceSink]);


  useEffect(()=>{
    selectedComplex(selected.complexInloNo);
  },[selected.sourceSink, selected.energy])

  const getComplexInloData = async () => {
    const uri = "vup/getComplexInloList"
    try {
      const res = await FxmsData.GET(uri);
      if(user.inloClCd === "PROJECT") {
        setFetchComplexInlo(res.data);
      } else {
        setFetchComplexInlo(res.data[0]);
        setSelected((prev) => {
          return { ...prev, complexInloNo: res.data[0].inloNo };
        })
      }
      console.log("complex List >> ", res.data);
    } catch (e) {
      console.log("getComplexInloList error ........", e);
    }
  }

    const selectedComplex = async (value) => {
        console.log("선택된 산단번호 ::", value);
        setSelected((prev) => ({ ...prev, complexInloNo: value }));
    
        if(value === "" || !value){
          setFetchCompanyInlo([]);
          setSelected((prev) => ({ ...prev, companyInloNo: "" }));
          setSelected((prev) => ({ ...prev, plantInloNo: "" }));
          setSelected((prev) => ({ ...prev, facNo: "" }));   
        } else {
          const param = {
            energy: selected.energy,
            sourceSink: selected.sourceSink,
            complexInloNo: value,
          }
            const uri = "vup/getCompanyInloListNew";
          try {
            const res = await FxmsData.GET(uri,param);       
            setFetchCompanyInlo(res.data); 
            console.log("company List >>", res.data); 
          } catch (e) {
            console.log("getCompanyInloList error.... ", e);
          }
        }
        setFetchPlantInlo([]); // 산단을 변경하면 plantInlo를 초기화
        console.log("selected ........", selected);
      }


    const selectedCompany = async (value) => {
      console.log("선택된 회사번호 :: ", value);
      setSelected((prev) => ({ ...prev, companyInloNo: value }));
  
      if(value===""){
        setFetchPlantInlo([]);
        setSelected((prev) => ({ ...prev, plantInloNo: value }));
        setSelected((prev) => ({ ...prev, facNo: value }));        
      }else{
        const uri = "vup/getPlantInloList/" + value;
        try {
          const res = await FxmsData.GET(uri);
          setFetchPlantInlo(res.data);
          
          console.log("plant List >>", res.data);
        } catch (e) {
          console.log("getPlantInloList error.... ", e);
        }
      }     
    }

    const onChangeDatas = (event) => {
      const { value, name } = event.target;       
      
      setSelected((prev) => {
        return { ...prev, [name]: value };
      })
    }


  const submitBtnClick = async () => {

    if (selected == null) return;

    if (parseInt(selected.startDate) > parseInt(selected.endDate)) {
      FxWindow.alert("조회 기간이 잘못되었습니다.", true);
      return;
    } else if (getMonthBetween(selected.startDate.replace(/-/gi, ""), selected.endDate.replace(/-/gi, "")) > 3*12)  {
      FxWindow.alert("최대 3년까지 조회 가능합니다.", true);      
      return;
    }

    const param = {
      energy: selected.energy,
      sourceSink: selected.sourceSink,
      complexInloNo: selected.complexInloNo,
      //companyInloNo: selected.companyInloNo,
      plantInloNo: selected.plantInloNo,
      startDate: (selected.startDate).replace(/-/gi, ""),
      endDate: (selected.endDate).replace(/-/gi, "")
    }
    try {
      const uri = "vup/select_6_2";
      const res = await FxmsData.GET(uri, param);
      console.log("UI_6_2 res........", res.data);

      FxWindow.alert(res.data.length + " 건의 데이터가 조회되었습니다.");
      
      setFetchData(res.data);
    } catch (e) {
      console.log("UI_6_2 fetchData error", e);
    }
  }



  return (
    <>
    <div className="predict">
      <div className="FxCrudFilter">
        <div className="FxFilterLeft">
          <label className="FxLabelSearch"></label>
          <select className="FxSelectSearch" name="energy" onChange={onChangeDatas}>
            {energyOptions.map((item, index) => (
              <option key={index} value={item.value} name="energy">{item.label}</option>
            ))}
          </select>
          <label className="FxLabelSearch"></label>
          <select className="FxSelectSearch" name="sourceSink" onChange={onChangeDatas}>
            {sourceSinkOptions.map((item, index) => (
              <option key={index} value={item.value} name="sourceSink">{item.label}</option>
            ))}
          </select>
          <label className="FxLabelSearch"></label>
          {user.ugrpNo === 1021 || user.ugrpNo === 1024 ?
          <select className="FxSelectSearch" name="complexInloNo" value={inlo.complexInloNo}>
           <option value={inlo.complexInloNo}> {inlo.complexInloName} </option>
           </select>
            :
            <select className="FxSelectSearch" onChange={(e) => selectedComplex(e.target.value)}>
                <option value="">산업단지 전체</option>
                {fetchComplexInlo.map((item) => (
                  <option key={item.inloNo} value={item.inloNo} name="complexInloNo">
                    {item.inloName}
                  </option>
                ))}
            </select>
            }  
            <label className="FxLabelSearch"></label>
            {user.ugrpNo === 1024 ?
           <select className="FxSelectSearch" name="companyInloNo" value={inlo.companyInloNo}>
           <option value={inlo.companyInloNo}> {inlo.companyInloName} </option>
           </select>
            :
            <select className="FxSelectSearch" onChange={(e) => selectedCompany(e.target.value)}>
                <option value="">회사 전체</option>
                {fetchCompanyInlo.map((item) => (
                  <option key={item.inloNo} value={item.inloNo} name="companyInloNo">
                    {item.inloName}
                  </option>
                ))}
            </select>          
            }
            <label className="FxLabelSearch"></label>
            {user.ugrpNo === 1024 ?
              <select className="FxSelectSearch" name="plantInloNo" value={inlo.inloNo}>
              <option value={inlo.inloNo}> {inlo.inloName} </option>
              </select> 
              :
             <select className="FxSelectSearch" name="plantInloNo" onChange={onChangeDatas}>
              <option value="">사업장 전체</option>
              {fetchPlantInlo?.map((item) => (
                <option key={item.inloNo} value={item.inloNo} name="plantInloNo">
                  {item.inloName}
                </option>
              ))}
            </select>  
            } 
        </div>
        <div className="FxFilterRight">
        <input className="FxDate" type="month" name="startDate"value={selected.startDate} onChange={onChangeDatas} />
          <label className="FxLabelSearch">~</label>
          <input className="FxDate" type="month" name="endDate" value={selected.endDate} onChange={onChangeDatas} />
          <input className="FxButtonSearch" type="button" value="조회" onClick={submitBtnClick}/>
        </div>
      </div>
      <div class="FxCrudDataGrid">
        {selected.energy && selected.sourceSink ?
          <div class="FxDataTitle">
            {energyLabel} {sinkSourceLabel} 결산내역
          </div>
        :
        null}
        <div class="FxMuiTable">
          <MuiTable
            tableRowDataList={sinkSourceLabel ==="매수"? UI_6_2_tableRow1:UI_6_2_tableRow2}
            rows={resultData}
            menuFullName ={props.menuFullName}       
            excelRows={resultExcelData}
          />
        </div>
      </div>
    </div>
    {
      isOpen ?
        <div>
          <UI_6_2_popup sourceSink={selected.sourceSink} sinkSourceLabel={sinkSourceLabel} popupData={popupData} closePopup={() => setIsOpen(false)}/>
        </div>
        : null
    }
    </>
  )

}